<template>
  <section class="gallery">
    <div class="container" id="gallery">
      <div class="text-content-wrapper">
        <h2>Gallery</h2>
      </div>

      <ul class="gallery-images">
        <li class="gallery-image" v-for="image in images">
          <div class="image-wrapper" v-on:click="showFullImage(image)">
            <img
              v-bind:class="{'portrait': image.portrait}"
              v-lazy-load:src="imagesPath + image.name + ''" alt=""
            />
          </div>
        </li>
        <li class="clearfix"></li>
      </ul>

      <div class="image-zoom" v-on:click="currentImage = null" v-bind:class="{'active': currentImage != null}">
        <img
          v-if="currentImage"
          v-bind:class="{'portrait': currentImage.portrait}"
          v-bind:src="imagesPath + currentImage.name + ''" alt=""
        />
      </div>
    </div>

  </section>
</template>

<script>

export default {
  name: 'promotions',
  created: function () {

  },
  data () {
    return {
      currentImage: null,
      imagesPath: './static/gallery/' ,
      images: [
        { name:'IMG-20250307-WA0016.jpg', portrait: false},
        { name:'IMG-20250307-WA0017.jpg', portrait: false},
        { name:'IMG-20250307-WA0019.jpg', portrait: false},
        { name:'IMG-20250307-WA0021.jpg', portrait: false},
        { name:'IMG-20250307-WA0022.jpg', portrait: false},
        { name:'IMG-20250307-WA0024.jpg', portrait: false},
        { name:'IMG-20250307-WA0025.jpg', portrait: false},
        { name:'IMG-20250307-WA0026.jpg', portrait: false},

        { name:'20240220_114959.jpg', portrait: false},
        { name:'20240220_115002.jpg', portrait: false},
        { name:'20240220_115004.jpg', portrait: false},
        { name:'20240220_115008.jpg', portrait: false},
        { name:'20240220_115032.jpg', portrait: false},
        { name:'20240220_115040.jpg', portrait: false},
        { name:'20240220_115114.jpg', portrait: false},
        { name:'20240220_115147.jpg', portrait: false},
        { name:'20240220_115304.jpg', portrait: false},
        { name:'20240220_112812.jpg', portrait: false},

        { name:'20210127_123739.jpg', portrait: false},
        { name:'20210128_123341.png', portrait: false},
        { name:'20220209_103307.jpg', portrait: false},
        { name:'20220209_105344.jpg', portrait: false},
        { name:'20220209_105455.jpg', portrait: false},
        { name:'20220209_105529.jpg', portrait: false},
        { name:'20220209_105733.jpg', portrait: false},
        { name:'20220301_111542.jpg', portrait: false},
        { name:'20220301_111555.jpg', portrait: false},
        { name:'20220301_111615.jpg', portrait: false},
        { name:'20220301_111720.jpg', portrait: false},
        { name:'20220301_111727.jpg', portrait: false},
        { name:'20220301_111753.jpg', portrait: false},
        { name:'20220301_111827.jpg', portrait: false},
        { name:'IMG-20220209-WA0006.jpg', portrait: false},
        

        /*{ name:'Hlabisa-Hamper-1---April.jpg', portrait: false},
        { name:'Hlabisa-Hamper-2---April.jpg', portrait: false},
        { name:'Hlabisa-Hamper-3---April.jpg', portrait: false},
        { name:'Hlabisa-Hamper-4---April.jpg', portrait: false},
        { name:'Hlabisa-Hamper-5--April.jpg', portrait: false},
        { name:'IMG-20200513-WA0002.jpg', portrait: false},
        { name:'IMG-20200513-WA0003.jpg', portrait: false},
        { name:'IMG-20200513-WA0004.jpg', portrait: false},
        { name:'IMG-20200513-WA0005.jpg', portrait: false},
        { name:'IMG-20200513-WA0006.jpg', portrait: false},
        { name:'IMG-20200513-WA0010.jpg', portrait: false},
        { name:'IMG-20200508-WA0004.jpg', portrait: false},
        { name:'IMG-20200508-WA0005.jpg', portrait: false},
        { name:'IMG-20200508-WA0006.jpg', portrait: false},
        { name:'IMG-20200508-WA0007.jpg', portrait: false},
        { name:'IMG-20200508-WA0009.jpg', portrait: false},
        { name:'IMG-20200513-WA0013.jpg', portrait: false},

        { name:'20171208_103014.jpg', portrait: false},
        { name:'20171208_101620.jpg', portrait: true},
        { name:'20171208_101628.jpg', portrait: false},
        { name:'20171208_102444.jpg', portrait: true},
        { name:'20171208_102852.jpg', portrait: false},
        { name:'20171208_102927.jpg', portrait: false},
        { name:'20171208_101155.jpg', portrait: true},
        { name:'IMG_9812.jpg', portrait: false},
        { name:'IMG_9816.jpg', portrait: false},
        { name:'IMG_9829.jpg', portrait: false},
        { name:'IMG_9830.jpg', portrait: true},
        { name:'IMG_9832.jpg', portrait: false},
        { name:'IMG_9836.jpg', portrait: false},
        { name:'IMG_9837.jpg', portrait: false},
        { name:'IMG_9839.jpg', portrait: false},
        { name:'IMG_9846.jpg', portrait: false},
        { name:'IMG_9848.jpg', portrait: false},
        { name:'IMG_9850.jpg', portrait: false},
        { name:'IMG_9852.jpg', portrait: false},
        { name:'IMG_9854.jpg', portrait: false},
        { name:'IMG_9857.jpg', portrait: false},
        { name:'IMG_9859.jpg', portrait: false},
        { name:'IMG_9860.jpg', portrait: false},
        { name:'IMG_9861.jpg', portrait: false},
        { name:'IMG_9862.jpg', portrait: false},
        { name:'IMG_9863.jpg', portrait: false}*/
      ]
    }
  },
  methods: {
    showFullImage: function(imageUrl){
      this.$data.currentImage = imageUrl
    }
  },
  computed: {
  },
  directives: {
    gallery: {
      // directive definition
      inserted: function (el) {
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import '../scss/colours.scss';
  @import '../scss/mixins.scss';
  @import '../scss/loader.scss';

  .gallery{
    margin-bottom: 4em;
  }

  img{
    &.loading{
      opacity: 0;
    }
  }

  .gallery-images{
    list-style: none;
    margin: 0;
    padding: 0;
  }

  .gallery-image{
    position: relative;
    width: 33%;
    height: auto;
    padding-bottom: 33%;
    float: left;

    @include breakpoint(md){
      width: 20%;
      height: auto;
      padding-bottom: 20%;
    }

    .image-wrapper{
      position: absolute;
      top: 5px;
      left: 5px;
      right: 5px;
      bottom: 5px;
      text-align: center;
      overflow: hidden;

      @include breakpoint(md){
        top: 10px;
        left: 10px;
        right: 10px;
        bottom: 10px;
      }
    }

    img{
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      display: block;
      width: auto;
      height: 100%;

      &.portrait{
        width: 100%;
        height: auto;
      }
    }
  }

  .image-zoom{
    z-index: 100;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(white, 0.75);
    pointer-events: none;
    opacity: 0;
    transition: opacity 0.25s ease-in-out;

    img{
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      max-height: 100%;
      max-width: 100%;
    }

    &.active{
      pointer-events: inherit;
      opacity: 1;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Gallery.vue